"use client";

import { createContext, useContext, useState } from 'react';

const FormContext = createContext();

export const FormProvider = ({ children }) => {
  const [formData, setFormData] = useState({
    situation: '',
    serviceType: '',
    regularizacionRequisitos: {
      q1: null,
      q2: null,
      q3: null,
      q4: null,
      q5: null,
      q6: null
    },
    iaDescription: '',
    contactInfo: {
      telephone: '',
      email: '',
    },
    personalInfo: {
      name: '',
      lastName: '',
      city: '',
      country: '',
      postalCode: '',
      street: '',
    },
    companyInfo: {
      name: '',
      city: '',
      postalCode: '',
      street: '',
      country: '',
    },
    files: [],
  });

  const updateFormData = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // Función para actualizar datos anidados
  const updateNestedData = (section, key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [section]: {
        ...prevData[section],
        [key]: value,
      },
    }));
  };

  // Función para actualizar archivos
  const setFiles = (files) => {
    setFormData((prev) => ({
      ...prev,
      files: files,
    }));
  };

  // Función para limpiar los datos
  const clearForm = () => {
    setFormData({
      situation: '',
      serviceType: '',
      regularizacionRequisitos: {
        q1: null,
        q2: null,
        q3: null,
        q4: null,
        q5: null,
        q6: null
      },
      iaDescription: '',
      contactInfo: {
        telephone: '',
        email: '',
      },
      personalInfo: {
        name: '',
        lastName: '',
        city: '',
        country: '',
        postalCode: '',
        street: '',
      },
      companyInfo: {
        name: '',
        city: '',
        postalCode: '',
        street: '',
        country: '',
      },
      files: [],
    });
  };


  return (
    <FormContext.Provider value={{ formData, updateFormData, updateNestedData, setFiles, clearForm }}>
      {children}
    </FormContext.Provider>
  );
};


export const useForm = () => {
  const context = useContext(FormContext);
  if (!context) {
    throw new Error('useForm debe ser usado dentro de un FormProvider');
  }
  return context;
};
